const login = {
    redirecting: '正在前往登录页面',
    redirectingDesc: '未检测到登录状态，正在为您跳转至统一认证中心...',
    failed: '暂时无法连接登录服务',
    failedDesc: '登录服务未响应。请检查网络或代理连接后重试。',
    retry: '重新登录',
  }

export default login
